import React,{Component} from 'react';


export default class Delete extends Component{
    constructor(props){
        super(props)
    }
    render(){
        return(
            <h1>Delete works</h1>
        )
    }
}